import 'mmenu-light/dist/mmenu-light';
import { retrieve } from './elements';
import 'bootstrap/js/dist/modal';
       
var wmElement = document.querySelector('#wm-mobile-menu');
var ahElement = document.querySelector('#ah-mobile-menu');
var wmButton = document.querySelector('a[href="#wm-mobile-menu"]');
var ahButton = document.querySelector('a[href="#ah-mobile-menu"]');
                
if (wmElement && wmButton) {
    new Promise(function (res, rej) {
        initializeMobileMenu('Western Mutual', wmElement, wmButton);
        res();
    }).then(function () {
        wmElement.style.display = 'block';
    });
}

if (ahElement && ahButton) {
    new Promise(function (res, rej) {
        initializeMobileMenu('Arizona Home', ahElement, ahButton);
        res();
    }).then(function () {
        ahElement.style.display = 'block';
    });
}

function initializeMobileMenu(title, menuElement, button) {

    var menu = new MmenuLight(
        menuElement,
        'all'
    );

    var navigator = menu.navigation({
        // selectedClass: 'Selected',
        slidingSubmenus: true,
        theme: 'light',
        title: title
    });

    var drawer = menu.offcanvas({
        position: 'left'
    });

    button.addEventListener('click', e => {
        e.preventDefault();
        drawer.open();
        toggleTabIndex('0');
        $('.mm-spn li > a').first().focus();
        $('html').on('click', () => {
            if ($('.mm-ocd--open').length === 0) {
                toggleTabIndex('-1');
                button.focus();
            }
        });
    });

    $('#mobile-retrieve').on('keypress', (e) => {
        if (e.which === 13) {
            e.currentTarget.click();
            setRetrieveTabIndex('0');
            $('#ccpaModal').on('hidden.bs.modal', function (e) {
                if ($('.mm-ocd--open').length > 0) {
                    retrieve.backMobile.focus();
                }
            });
        }
    });

    retrieve.ccpaMobile.on('click', e => {
        e.preventDefault();
        $('#ccpaModal').modal('show');
    });

    retrieve.backMobile.on('click', (e) => {
        e.preventDefault();
        $('.mm-spn.mm-spn--navbar').click();
        $('.mm-spn li > a').first().focus();
        $('#ccpaModal').off('hidden.bs.modal');
        setRetrieveTabIndex('-1');
    });

    $('#menu-close').on('click', e => {
        e.preventDefault();
        drawer.close();
        if ($('.mm-ocd--open').length === 0) {
            toggleTabIndex('-1');
            button.focus();
            $('html').off('click');
        }
    });

    function toggleTabIndex(value) {
        var clickables = $('.mm-spn > ul > li > a, .mm-spn > ul > li > span');
        clickables.attr('tabindex', value);
    }

    function setRetrieveTabIndex(value) {
        retrieve.backMobile.attr('tabindex', value);
        retrieve.referenceNumberMobile.attr('tabindex', value);
        retrieve.zipCode5Mobile.attr('tabindex', value);
        retrieve.ccpaMobile.attr('tabindex', value);
        retrieve.buttonSubmitMobile.attr('tabindex', value);
    }
}